// extracted by mini-css-extract-plugin
module.exports =  {"daterange":"rxxlDS21bV34IFhGAIhw"};